const loadingStateSelector = (state, loader) => state.loadingState[loader];

export { loadingStateSelector };
